'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './custom-view.routes';
var pluralize = require('pluralize');

const unflatten = require('flat').unflatten;

export class CustomViewComponent {
  constructor(Auth, CustomViewService, dialogs, $uibModal, $stateParams, SettingsService, $filter, DTOptionsBuilder,
              DTState, Util) {
    'ngInject';
    this.CustomViewService = CustomViewService;
    this.isAdmin = Auth.isAdminSync;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.$filter = $filter;

    this.type = $stateParams.type;

    SettingsService.getByName({name: "custom-views"}, settings => {
      this.config = settings.data[this.type].view;

      let oSortOrder = this.config.order || [0, 'asc'];

      this.dtOptions = DTOptionsBuilder
        .newOptions()
        .withOption('dom', 'lBfrtip')
        .withOption('order', oSortOrder)
        .withOption('stateSave',true)
        .withOption('stateSaveCallback', DTState.save())
        .withOption('stateLoadCallback', DTState.restore())
        .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
        .withOption('buttons',[{
          extend: 'excel',
          title: this.config.title,
          exportOptions: {
            orthogonal: 'export',
          }
        },{
          extend: 'csv',
          title: this.config.title,
          exportOptions: {
            orthogonal: 'export',
          }
        },{
          title: this.config.title,
          message: 'As of ' + moment().format("MMMM Do YYYY"),
          extend: 'pdf',
          orientation: 'portrait',
          pageSize: 'LETTER',
          exportOptions: {
            orthogonal: 'export',
          }
        },{
          extend: 'print',
          title: this.config.title,
          exportOptions: {
            orthogonal: 'export',
          }
        }]);

      if (this.config.rowGroup) {
        this.dtOptions.rowGroup = {
          dataSrc: this.config.rowGroup
        };

        this.dtOptions.columnDefs = [ {
          targets: this.config.rowGroup,
          visible: false
        } ];
      }

      for (let i=0; i<this.config.colDefs.length; i++) {
        if (this.config.colDefs[i].exportBreakToNewline) {
          if (!this.dtOptions.columnDefs || !Array.isArray(this.dtOptions.columnDefs))
            this.dtOptions.columnDefs = [];

          this.dtOptions.columnDefs.push({
            targets:[i],
            render: Util.dataTableExportBreakToNewlineRenderer
          })

          //console.log("added", this.dtOptions.columnDefs)
        }
      }

      console.log(this.config.colDefs, this.dtOptions);
    }, _=> {
      console.log("Could not retrieve custom views settings");
    });

    let METHOD = (this.script) ? "getCustomViewScript" : "getCustomView";

    this.CustomViewService[METHOD]({type: this.type}, data => {
      this.data = data;
    }, err => {
      console.log("Could not retrieve custom view data.")
    });


    /*
    this.dtOptions = DTOptionsBuilder
      .newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'asc']);*/
  }

  getComposedName(contact) {
    let composedName = "";

    if (!contact) {
      return "Removed Contact";
    }

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "") {
        composedName += contact.company;
      } else {
        composedName += "<br/>" + contact.company;
      }
    }

    return composedName;
  }

  getFromByContactId(entry, contactId, path) {
    let oEntry = unflatten(entry);

    let ref = oEntry.property;
    if (path)
      ref = oEntry[path];

    let matchContact = ref.contacts.find(c => c.contact == contactId);
    if (matchContact)
      return (matchContact.from) ? matchContact.from : "";

    return "";
  }

  getTillByContactId(entry, contactId, path) {
    let oEntry = unflatten(entry);

    let ref = oEntry.property;
    if (path)
      ref = oEntry[path];

    let matchContact = ref.contacts.find(c => c.contact == contactId);
    if (matchContact)
      return (matchContact.till) ? matchContact.till : "";

    return "";
  }

  getActiveTenant(entry, path) {
    let oEntry = unflatten(entry);

    let ref = oEntry.property;
    if (path)
      ref = oEntry[path];

    let activeTenant = ref.contacts.find(contact => {
      try {
        if (contact.type == 'renter') {

          if (!contact.from && !contact.till) // if no dates are defined, we assume thatt the renter should be the current one
            return true;

          if (contact.from && contact.till) {
            return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
          }

          if (!contact.from && contact.till) {
            return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
          }

          if (contact.from && !contact.till) {
            return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
          }
        } else {
          return false;
        }

      } catch(e) {
        console.log(e);
        return null;
      }
    });

    if (!activeTenant)
      return null;

    return activeTenant.contact;
  }

  getContactId(contact) {
    return contact._id;
  }

  getActiveTenantName(entry, path) {
    let oEntry = unflatten(entry);

    let ref = oEntry.property;
    if (path)
      ref = oEntry[path];

    let activeTenant = ref.contacts.find(contact => {
      try {
        if (contact.type == 'renter') {

          if (!contact.from && !contact.till) // if no dates are defined, we assume thatt the renter should be the current one
            return true;

          if (contact.from && contact.till) {
            return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
          }

          if (!contact.from && contact.till) {
            return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
          }

          if (contact.from && !contact.till) {
            return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
          }
        } else {
          return false;
        }

      } catch(e) {
        console.log(e);
        return "-";
      }
    });

    if (!activeTenant)
      return "-";

    return this.getComposedName(activeTenant.contact);
  }

  getActiveTenantsNames(entry, path, joinSymbol="<br/>") {
    let oEntry = unflatten(entry);

    let ref = oEntry.property;
    if (path)
      ref = oEntry[path];

    let allActivateTenants = ref.contacts.filter(contact => {
      try {
        if (contact.type == 'renter') {

          if (!contact.from && !contact.till) // if no dates are defined, we assume thatt the renter should be the current one
            return true;

          if (contact.from && contact.till) {
            return moment().isBetween(moment(contact.from), moment(contact.till), "days", "[]");
          }

          if (!contact.from && contact.till) {
            return moment().isBefore(moment(contact.till)) || moment.isSame(moment(contact.till), "day");
          }

          if (contact.from && !contact.till) {
            return moment().isAfter(moment(contact.from)) || moment.isSame(moment(contact.from), "day");
          }
        } else {
          return false;
        }

      } catch (e) {
        console.log(e);
        return false;
      }
    });

    if (!allActivateTenants.length)
      return "-";

    let allNames = allActivateTenants.map(o => this.getComposedName(o.contact));

    return allNames.join(joinSymbol);
  }

  getPrimaryOwnerName(entry, path) {
    let oEntry = unflatten(entry);

    let ref = oEntry.property;
    if (path)
      ref = oEntry[path];

    let primary = ref.contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return "-";

    return this.getComposedName(primary.contact);
  }

  getOtherOwnerName(entry, path) {
    let oEntry = unflatten(entry);

    let ref = oEntry.property;
    if (path)
      ref = oEntry[path];

    let other = ref.contacts.find(contact => contact.type == 'owner');

    if (!other)
      return "-";

    return this.getComposedName(other.contact);
  }

  getPrimaryOwner(entry, path) {
    let oEntry = unflatten(entry);

    let ref = oEntry.property;
    if (path)
      ref = oEntry[path];

    let primary = ref.contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return null;

    return primary.contact;
  }

  getContactNameByTypeAndIndex(entry, path, type, index) {
    let oEntry = unflatten(entry);

    let ref = oEntry.property;
    if (path)
      ref = oEntry[path];

    let allByType = ref.contacts.filter(contact => contact.type == type);
    let matchedByIndex = allByType[index];

    if (!matchedByIndex)
      return "-";

    return this.getComposedName(matchedByIndex.contact);
  }

  getContactNamesByType(entry, path, type, joinSymbol="<br/>") {
    let oEntry = unflatten(entry);

    let ref = oEntry.property;
    if (path)
      ref = oEntry[path];

    let allByType = ref.contacts.filter(contact => contact.type == type);

    if (!allByType.length)
      return "-";

    let allNames = allByType.map(o => this.getComposedName(o.contact));

    return allNames.join(joinSymbol);
  }

  getPrimaryAddress(contact) {
    if (!contact || !contact.address || !contact.address.length)
      return "-";

    let address = contact.address.find(adr => adr.isPrimary) || contact.address[0] || {};

    return address.street + "<br/>" + address.city + ' ' + address.state + ', ' + address.zip;
  }

  getPrimaryAddressFlatted(entry, path) {
    let oEntry = unflatten(entry);

    let ref = oEntry.contact;
    if (path)
      ref = oEntry[path];

    return this.getPrimaryAddress(ref);
  }

  getPrimaryEmailFlatted(entry, path) {
    let oEntry = unflatten(entry);

    let ref = oEntry.contact;
    if (path)
      ref = oEntry[path];

    return this.getPrimaryEmailSoftBreak(ref);
  }

  getPrimaryPhoneFlatted(entry, path) {
    let oEntry = unflatten(entry);

    let ref = oEntry.contact;
    if (path)
      ref = oEntry[path];

    return this.getPrimaryPhone(ref);
  }

  getOtherOwner(entry, path) {
    let oEntry = unflatten(entry);

    let ref = oEntry.property;
    if (path)
      ref = oEntry[path];

    let other = ref.contacts.find(contact => contact.type == 'owner');

    if (!other)
      return null;

    return other.contact;
  }

  getPrimaryEmailSoftBreak(contact) {
    let email = this.getPrimaryEmail(contact);

    return email
      .replace('@','@&#8203;')
      .replace('.','&#8203;.')
      .replace('-','-&#8203;')
      .replace('_','_&#8203;');
  }

  getPrimaryEmail(contact) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    return email.address;
  }

  getPrimaryPhone(contact) {
    if (!contact || !contact.phone || !contact.phone.length)
      return "-";

    let phone = contact.phone.find(phone => phone.isPrimary) || contact.phone[0] || {number:'-'};

    return phone.number;
  }

  getPrimaryAddress(contact) {
    if (!contact || !contact.address || !contact.address.length)
      return "-";

    let address = contact.address.find(adr => adr.isPrimary) || contact.address[0] || {};

    return address.street + "<br/>" + address.city + ' ' + address.state + ', ' + address.zip;
  }
}

export default angular.module('conduu.customView', [uiRouter])
  .config(routes)
  .component('customView', {
    template: require('./custom-view.html'),
    controller: CustomViewComponent,
    controllerAs: 'ctrl',
    bindings: {
      script: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/custom/view/custom-view.component.js